export default __webpack_public_path__ + "59c1353806a0613ead84e446dc47dfbf.png";